module.exports = __webpack_public_path__ + "img/parental.04e214c7.png";